var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SoundslidesPlayer',{attrs:{"path":_vm.path,"fillscreen":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }